import React, {useMemo} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {formatNumber} from "../Statistics/format.js";
import {HOURS, WEEKDAY_LABELS, WEEKDAY_LABELS_LONG, heatmapColor} from "./format.js";

/**
 * Reine Darstellungs-Komponente für eine Wochentag×Stunde-Heatmap - als
 * CSS-Grid statt mit recharts (siehe Auftrag). Wird sowohl für den
 * Überblick (/nutzung/daten/heatmap) als auch für das Arbeitszeitmuster im
 * Mitarbeiterprofil verwendet - beide liefern dieselbe Form
 * {wochentag 1-7, stunde 0-23, wert}. Jede Kachel bekommt ein eigenes,
 * selbst gestaltetes Tooltip (react-bootstrap Overlay/Tooltip, das im
 * Haus als Ersatz für das native title-Attribut gilt, siehe HelpTooltip)
 * statt eines title-Attributs.
 */
export default function NutzungHeatmapGrid({rows}) {
    const {lookup, max} = useMemo(() => {
        const map = new Map();
        let maxValue = 0;
        (rows || []).forEach((row) => {
            map.set(`${row.wochentag}-${row.stunde}`, row.wert);
            if (row.wert > maxValue) {
                maxValue = row.wert;
            }
        });
        return {lookup: map, max: maxValue};
    }, [rows]);

    return (
        <div style={{overflowX: "auto"}}>
            <div
                style={{
                    display: "inline-grid",
                    gridTemplateColumns: "40px repeat(24, minmax(20px, 1fr))",
                    gap: 2,
                    minWidth: 640,
                }}
            >
                <div />
                {HOURS.map((stunde) => (
                    <div key={stunde} className="text-center text-muted" style={{fontSize: "0.65rem"}}>
                        {stunde % 3 === 0 ? stunde : ""}
                    </div>
                ))}
                {WEEKDAY_LABELS.map((label, weekdayIndex) => {
                    const wochentag = weekdayIndex + 1;
                    return (
                        <React.Fragment key={label}>
                            <div className="small text-muted d-flex align-items-center">{label}</div>
                            {HOURS.map((stunde) => {
                                const wert = lookup.get(`${wochentag}-${stunde}`) || 0;
                                const beschriftung = `${WEEKDAY_LABELS_LONG[weekdayIndex]}, ${stunde} Uhr: ${formatNumber(wert)}`;
                                return (
                                    <OverlayTrigger key={stunde} placement="top" overlay={<Tooltip>{beschriftung}</Tooltip>}>
                                        <button
                                            type="button"
                                            className="border-0 rounded-1"
                                            style={{
                                                width: "100%",
                                                aspectRatio: "1",
                                                minHeight: 18,
                                                backgroundColor: heatmapColor(wert, max),
                                                cursor: "default",
                                            }}
                                            aria-label={beschriftung}
                                        />
                                    </OverlayTrigger>
                                );
                            })}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}
